import * as React from "react"
import * as styles from "./styles.module.scss"
import Button from "../../Button"
import cx from "classnames"
import Link from "gatsby-link"

export enum GetStartedType {
  ON_SCROLL = "onScroll",
  ALWAYS = "always",
}

export interface GetStartedButtonProps {
  getStartedType: GetStartedType
  getStartedLink?: string
  scrolled: boolean
}

const GetStartedButton: React.FC<GetStartedButtonProps> = ({
  getStartedType = GetStartedType.ON_SCROLL,
  getStartedLink,
  scrolled,
}) => {
  const isScrolled =
    getStartedType === GetStartedType.ALWAYS ||
    (getStartedType === GetStartedType.ON_SCROLL && scrolled)
  return (
    <div
      className={cx({
        [styles.button]: true,
        [styles.isScrolled]: isScrolled,
      })}
    >
      <Link to={getStartedLink || "/start"} data-qa="get-started">
        <Button size="md" type="primary">
          Get Started
        </Button>
      </Link>
    </div>
  )
}
export default GetStartedButton
